import { AssignedProjectsPage } from './AssignedProjectsPage'

export function ClientDashboard() {
  return <AssignedProjectsPage title="Client Dashboard" field="clientUid" />
}
